import http from '../../services/httpService';

const apiEndpoint = '/errors/';

export const postErrorReport = async (errorObj) => {
  const result = await http.post(apiEndpoint, { data: errorObj });

  return result;
};
